import DatetimePicker from "vuetify-datetime-picker";

export default DatetimePicker;
